import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../graphql/types.generated';
export type GetPurchaseOrderReferencesQueryVariables = GraphQLTypes.Exact<{
  ids: Array<GraphQLTypes.Scalars['String']['input']> | GraphQLTypes.Scalars['String']['input'];
}>;

export type GetPurchaseOrderReferencesQueryResult = { __typename?: 'Query' } & {
  purchaseOrders: { __typename?: 'PurchaseOrderConnection' } & {
    nodes?: GraphQLTypes.Maybe<
      Array<
        GraphQLTypes.Maybe<{ __typename?: 'PurchaseOrder' } & Pick<GraphQLTypes.PurchaseOrder, 'id' | 'orderReferenceNumber'>>
      >
    >;
  };
};

export const GetPurchaseOrderReferencesDocument = gql`
  query getPurchaseOrderReferences($ids: [String!]!) {
    purchaseOrders(ids: $ids) {
      nodes {
        id
        orderReferenceNumber
      }
    }
  }
`;
